import React, { useState } from 'react';
import { 
  Card, 
  CardContent, 
  TextField, 
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DescriptionIcon from '@mui/icons-material/Description';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import LexicalEditor from '../Editor';

/**
 * 引導單元卡片組件
 * @param {Object} node - 節點數據
 * @param {number} index - 節點索引
 * @param {Function} onTitleChange - 標題變更回調
 * @param {Function} onContentChange - 內容變更回調
 * @param {Function} onRemove - 刪除回調
 * @param {Object} nodePlan - 節點計劃配置
 */
const InitialNodeCard = ({
  node,
  index,
  onTitleChange,
  onContentChange,
  onRemove,
  onAddAfter,
  nodePlan,
  compact = false
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  if (compact && !isEditing) {
    return (
      <Card variant="outlined" sx={{ cursor: 'pointer' }} onClick={() => setIsEditing(true)}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1 }}>
          <DescriptionIcon color="primary" fontSize="small" />
          <Typography sx={{ flex: 1 }} noWrap>{node.title || '未命名任務'}</Typography>
          {/\.pdf|application\/pdf/i.test(node.content || '') && (
            <PictureAsPdfIcon color="error" fontSize="small" />
          )}
          <IconButton
            size="small"
            color="primary"
            aria-label="在下方新增任務"
            onClick={(e) => { e.stopPropagation(); onAddAfter && onAddAfter(node.id); }}
          >
            <AddCircleOutlineIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" aria-label="更多" onClick={(e) => { e.stopPropagation(); setMenuAnchor(e.currentTarget); }}>
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)} onClick={(e) => e.stopPropagation()}>
            <MenuItem onClick={() => { setMenuAnchor(null); setIsEditing(true); }}>編輯內容</MenuItem>
            <MenuItem onClick={() => { setMenuAnchor(null); onAddAfter && onAddAfter(node.id); }}>在下方新增任務</MenuItem>
            <MenuItem sx={{ color: 'error.main' }} onClick={() => { setMenuAnchor(null); onRemove(index); }}>刪除任務</MenuItem>
          </Menu>
        </Box>
      </Card>
    );
  }
  return (
    <Card sx={{ position: 'relative' }}>
      <IconButton
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1
        }}
        onClick={() => onRemove(index)}
        aria-label="刪除節點"
      >
        <DeleteIcon />
      </IconButton>
      <CardContent>
        {compact && (
          <Typography
            variant="caption"
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={() => setIsEditing(false)}
          >
            ▲ 收合
          </Typography>
        )}
        <TextField
          fullWidth
          label="標題"
          value={node.title || ''}
          onChange={(e) => onTitleChange(index, e.target.value)}
          sx={{ mb: 2 }}
          placeholder="輸入節點標題"
        />
        <Typography variant="subtitle1" sx={{ mb: 1 }}>內容</Typography>
        <LexicalEditor
          changeFunc={(content) => onContentChange(index, content)}
          nodePlan={{
            ...nodePlan,
            intro: node.content || '請在這邊填寫節點內容'
          }}
        />
      </CardContent>
    </Card>
  );
};

export default InitialNodeCard;
